export const administracionAccionesRoles = {
  sideNavActions: {
    adminitracion: [],
    filterList: ['Chief', 'Admin'],
    userList: ['Chief', 'Admin', 'HumanResources'],
    userRecipients: ['Chief', 'Admin'],
    userEmailRecipients: ['Chief', 'Admin'],
    eficiencies: [
      'Chief',
      'Admin',
      'StandardsAdmin',
      'Viewer',
      'StandardsViewer',
      'StandardsModifier',
    ],
  },
};
